export default __webpack_public_path__ + "static/assets/9f01dd96f90230cc8f03c5b6f31829bc.svg";